import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { colors } from '@skyslope/mache';
import SellersShieldGif from '../../gifs/sellersshield_gif.gif';
import { ReactComponent as SellersShieldLogo } from '../../images/sellers-shield-logo.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    maxWidth: '1200px',
    margin: '32px auto',
    padding: theme.spacing(4),
    backgroundColor: colors.grey[50],
    borderRadius: '12px',
    gap: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      padding: theme.spacing(3),
      gap: theme.spacing(3),
    },
  },
  gifContainer: {
    flex: '0 0 auto',
    [theme.breakpoints.up('md')]: {
      maxWidth: '400px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  gif: {
    width: '100%',
    height: 'auto',
    border: `1px solid ${colors.grey[300]}`,
    borderRadius: '8px',
  },
  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  logo: {
    height: '32px',
    width: 'auto',
  },
  headline: {
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '32px',
    color: colors.grey[900],
    marginBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      lineHeight: '28px',
    },
  },
  bulletList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    paddingLeft: 0,
    marginTop: theme.spacing(1),
    listStyle: 'none',
  },
  bulletItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    fontSize: '16px',
    lineHeight: '24px',
    color: colors.grey[800],
  },
  bulletIcon: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: colors.blue[500],
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    fontWeight: 'bold',
    flexShrink: 0,
    marginTop: '2px',
  },
}));

export function SellersShieldPromoBanner() {
  const classes = useStyles();

  return (
    <div className={classes.root} data-spec="sellers-shield-promo-banner">
      <div className={classes.gifContainer}>
        <img
          src={SellersShieldGif}
          alt="Sellers Shield tutorial animation"
          className={classes.gif}
          loading="lazy"
          decoding="async"
        />
      </div>

      <div className={classes.content}>
        <SellersShieldLogo className={classes.logo} aria-label="Sellers Shield logo" role="img" focusable="false" />

        <Typography variant="h2" component="h3" className={classes.headline}>
          Why put your clients at risk of a lawsuit? Use Sellers Shield.
        </Typography>

        <ul className={classes.bulletList}>
          <li className={classes.bulletItem}>
            <span className={classes.bulletIcon}>✓</span>
            <span>Step-by-Step Guidance</span>
          </li>
          <li className={classes.bulletItem}>
            <span className={classes.bulletIcon}>✓</span>
            <span>Faster Disclosures</span>
          </li>
          <li className={classes.bulletItem}>
            <span className={classes.bulletIcon}>✓</span>
            <span>Fewer Mistakes</span>
          </li>
          <li className={classes.bulletItem}>
            <span className={classes.bulletIcon}>✓</span>
            <span>Protect your clients</span>
          </li>
        </ul>
      </div>
    </div>
  );
}
